/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:23]
Permissions to update outside the main branch: [false]
*/

import DictItem from 'models/api/dictItem';
import Table from 'models/api/table';
import { TranslateTable, TranslationWorkplace } from 'models/translateWorkplace';

export const translatorToWorkplace = (
    items: Table<TranslateTable>,
    cultures: DictItem[]
): Table<TranslationWorkplace> => {
    return {
        rowsCount: items.rowsCount,
        data: items.data.map((i) => {
            const item: TranslationWorkplace = {
                brandCode: i.brandCode,
                dictCode: i.dictCode,
                dictItemCode: i.dictItemCode,
                name: i.name,
                type: i.type,
                translations: i.translations,
                code: i.code,
                id:
                    (i.brandCode || '') +
                    '_' +
                    (i.type || '') +
                    '_' +
                    (i.name || '') +
                    '_' +
                    (i.dictCode || ''),
            };

            return item;
        }),
    };
};
